import React, { useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Wizard } from 'react-use-wizard';
import text from '../../../../text';
import ProjectNameForm from '../../ProjectNameForm';
import { useGetJobQuery } from '../../../../redux/rtk';
import { useRedirect } from '../../../../hooks/useRedirect';
import routes from '../../../../routes/constants';
import { hideModal } from '../../../../redux/actions';
export var MP_SAVE_DRAFT_MODAL = 'MP_SAVE_DRAFT_MODAL';
var MpSaveDraftModal = function(param) {
    var jobId = param.jobId, show = param.show, onSubmit = param.onSubmit;
    var redirect = useRedirect();
    var dispatch = useDispatch();
    var _useGetJobQuery = useGetJobQuery(jobId), job = _useGetJobQuery.data;
    var handleHide = useCallback(function() {
        return dispatch(hideModal(MP_SAVE_DRAFT_MODAL));
    }, [
        dispatch
    ]);
    var handleContinue = useCallback(function(values) {
        onSubmit(values);
        redirect.push(routes.dashboard);
        handleHide();
    }, [
        handleHide,
        onSubmit,
        redirect
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: handleHide
    }, /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement(Wizard, null, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h2", {
        className: "text-center w-100"
    }, text('enterProjectName')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center mb-1"
    }, text('yourProjectSavedAsDraft')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('accessDraftsAnytime')), /*#__PURE__*/ React.createElement(ProjectNameForm, {
        // @ts-expect-error no prop
        project: {
            name: job === null || job === void 0 ? void 0 : job.project.name
        },
        onContinue: function(values) {
            return handleContinue({
                projectName: values.name
            });
        },
        onCancel: handleHide,
        onContinueText: text('goToDashboard')
    })))));
};
export default MpSaveDraftModal;
